import { UrlCell } from "app/components/React/Table/cells/UrlCell";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { ChipItemTableCell } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import styled from "styled-components";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import type { FC } from "react";

const UrlsAmountWrapper = styled.div`
    margin-left: 4px;
`;

const UrWithAdditionalAmountCellWrapper = styled(FlexRow)`
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 0 12px;
    height: 41px;
    box-sizing: border-box;
`;

export const UrlWithAdditionalAmountCell: FC<ITableCellProps> = (props) => {
    const { value } = props;
    const { site, displayedSite, amountOfAdditionalSites, tooltipAdditionalSites } = value;
    return (
        <UrWithAdditionalAmountCellWrapper className="url-cell-content">
            {site ? (
                <UrlCell
                    site={site}
                    displayedSite={displayedSite}
                />
            ) : null}
            {amountOfAdditionalSites > 0 ? (
                <PlainTooltip
                    placement="top"
                    tooltipContent={tooltipAdditionalSites}
                    cssClass="plainTooltip-element search-keyword-cell-tooltip"
                >
                    <UrlsAmountWrapper>
                        <ChipItemTableCell
                            text={`+${amountOfAdditionalSites}`}
                            hideActionButton={true}
                        />
                    </UrlsAmountWrapper>
                </PlainTooltip>
            ) : null}
        </UrWithAdditionalAmountCellWrapper>
    );
};
